import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const SUBSTANCE_IDENTIFIER = {
  system: 'http://compassion.narushealth.com/substance-use'
}

const loincCode = (code, display) => ({
  coding: [
    {
      system: 'http://loinc.org',
      code,
      display
    }
  ],
  text: display
})

const socialHxCagetory = () => ({
  text: 'Social History',
  coding: [
    {
      code: 'social-history',
      system: 'http://hl7.org/fhir/observation-category',
      display: 'Social History'
    }
  ]
})

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Observation'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'category', 0 ],
    fhir_const: socialHxCagetory()
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'final'
  },
  {
    fhir: [ 'identifier', SUBSTANCE_IDENTIFIER, 'value' ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'code' ],
    fhir_const: loincCode('28355-6', 'Substance Use Status')
  },
  {
    fhir: [ 'valueString' ],
    form: [ 'amount' ]
  },
  {
    fhir: [ 'component', 0, 'code', 'coding', 0 ],
    form: [ 'route' ]
  },
  {
    fhir: [ 'effectivePeriod', 'start' ],
    form: [ 'start' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'effectivePeriod', 'end' ],
    form: [ 'stop' ],
    to_fhir: form2fhir
  }
]

export const mapSubstanceUse = (form, patientId) => {
  const res = transform(form, mapping, [ 'form', 'fhir' ])
  res.subject = { reference: `Patient/${patientId}` }
  return res
}

export const unmapSubstanceUse = data =>
  transform(data, mapping, [ 'fhir', 'form' ])
